var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"blank",attrs:{"widget-type":"blank"}},[_vm._t(_vm.widget.model,null,{"value":_vm.value,"dataModel":_vm.fieldName,"wg":_vm.widget.model,"options":_vm.widget.options})],2)}
var staticRenderFns = []

export { render, staticRenderFns }